export default class GetSolutionError extends Error {
}
